import * as React from 'react';

export function AccountingOwnership(): JSX.Element {
  return (
    <div className="row center-xs">
      <h3>Are you sure you want to take over ownership of this Contract Cancellation?</h3>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/accounting/_components/accounting-list/accounting-ownership.component.tsx